'use strict';

function crossfilter_null() {
  return null;
}

module.exports = crossfilter_null;
